module.exports = __webpack_public_path__ + "static/img/fache_shadow.b41b0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/fache_shadow.png
// module id = ny0y
// module chunks = 0